import { type ApiScopeBase, type Branded, brand } from '@ipfabric/utils';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GlobalStateMergedState } from 'components/GlobalState/GlobalStateModel';
import { array } from 'fp-ts';
import { flow } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

/**
 * method/path pair serialized to a single string for simpler comparisons and queries in Set etc
 */
export type ApiScopeString = Branded<string, 'apiScope'>;

export const getApiScopeString = ({
  path,
  method,
}: ApiScopeBase): ApiScopeString => brand<ApiScopeString>(`${method}:${path}`);

export const selectApiScopeStringSet: (
  s: GlobalStateMergedState,
) => Set<ApiScopeString> = createScopedSelector(() =>
  createSelector(
    prop('auth', 'apiScopes'),
    flow(array.map(getApiScopeString), plainSet.fromArray),
  ),
);
